import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router';
import * as Sentry from '@sentry/react';

import { SENTRY_STAGE } from '@/utils/constants';

Sentry.init({
  dsn: 'https://99439d97a74a9f1eef30b37338a97421@o4506361348358144.ingest.sentry.io/4506361355960320',
  enabled: SENTRY_STAGE !== 'development',
  environment: SENTRY_STAGE,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      createRoutesFromChildren,
      matchRoutes,
      useEffect,
      useLocation,
      useNavigationType,
    }),
  ],
  sendDefaultPii: true,
});

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
